import dexieLogo from "../../../Images/dexieLogo.webp";
import reactRouterLogo from "../../../Images/reactRouterLogo.webp";

export const skillsData = {
  javaScript: {
    name: "JavaScript",
    iconSrc:
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
  },
  typeScript: {
    name: "TypeScript",
    iconSrc:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/typescript/typescript-original.svg",
  },
  html: {
    name: "HTML",
    iconSrc:
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-plain.svg",
  },
  css: {
    name: "CSS",
    iconSrc:
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-plain.svg",
  },
  react: {
    name: "React",
    iconSrc:
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
  },
  materialUI: {
    name: "Material UI",
    iconSrc:
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/materialui/materialui-plain.svg",
  },
  nodeJS: {
    name: "Node.js",
    iconSrc:
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-plain.svg",
  },
  git: {
    name: "Git",
    iconSrc:
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-plain.svg",
  },
  styledComponents: {
    name: "Styled Components",
    iconSrc: "https://avatars.githubusercontent.com/u/20658825?s=200&v=4",
  },
  indexedDB: {
    name: "IndexedDB, Dexie.js",
    iconSrc: dexieLogo,
  },
  reactRouter: {
    name: "React Router",
    iconSrc: reactRouterLogo,
  },
  firebase: {
    name: "Firebase",
    iconSrc:
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain-wordmark.svg",
  },
  framerMotion: {
    name: "Framer Motion",
    iconSrc:
      "https://seeklogo.com/images/F/framer-motion-logo-DA1E33CAA1-seeklogo.com.png",
  },
  aspNet: {
    name: "ASP.Net Core",
    iconSrc:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/dot-net/dot-net-original-wordmark.svg",
  },
  azure: {
    name: "Azure",
    iconSrc:
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-original.svg",
  },
  mongoDb: {
    name: "MongoDb",
    iconSrc: 
    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg"
  },
  msSql: {
    name: "MsSQL",
    iconSrc: 
    "https://www.svgrepo.com/show/303229/microsoft-sql-server-logo.svg"
  },
  axios: {
    name: "Axios",
    iconSrc: 
    "https://tannerfriedman.com/wp-content/uploads/2022/08/91-913031_axios-axios-logo-hd-png-download.png"
  },
  tailwindcss: {
    name: "Tailwindcss",
    iconSrc: 
    "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tailwindcss/tailwindcss-original-wordmark.svg"
  }
};

export const skillsSectionData = [
  "javaScript",
  "typeScript",
  "html",
  "css",
  "react",
  "materialUI",
  "git",
  "styledComponents",
  "aspNet",
  "tailwindcss"
];
